import styled from 'styled-components';

import { Headline, Paragraph } from 'ggApp/shared/common/Typography';
import { Modal } from 'ggApp/modules/modal/components/v3';
import { SonntagButtonV2 } from '@getgrover/ui';

const MODAL_CONTAINER_CLASS_NAME = 'waitingListModalContainer';
const MODAL_CONTENT_CLASS_NAME = 'waitingListModalContent';
const MODAL_ACTIONS_CONTAINER_CLASS_NAME = 'waitingListActionsContainer';

export const StyledModal = styled(Modal).attrs({
    classNames: {
        content: MODAL_CONTENT_CLASS_NAME,
        container: MODAL_CONTAINER_CLASS_NAME,
        actionsContainer: MODAL_ACTIONS_CONTAINER_CLASS_NAME,
    },
})`
    /* Using this hack to override base styles */

    & .${MODAL_CONTAINER_CLASS_NAME} {
        width: 900px;
        padding: 0;
        height: auto;
        max-width: 900px;
        max-height: 100%;
        min-width: unset;
        min-height: 640px;

        ${({ theme }) => theme.superQuery.all.and.maxWidth.desktopMin.css`
            width: 350px;
        `};

        @media only screen and (max-height: 640px) {
            min-height: 100%;
        }
    }
    & .${MODAL_CONTENT_CLASS_NAME} {
        padding: 0px;
    }
`;

export const ContentWrap = styled.div`

    margin: 24px 0px 24px 24px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.desktopMin.css`
         margin: 16px 16px 16px 16px;
    `};
`;

export const Text = styled(Paragraph)`
    margin-bottom: ${({ theme }) => theme.spacers.L};
`;

export const TextBottom = styled(Paragraph)`
    margin: ${({ theme }) => theme.spacers.L} 0px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.desktopMin.css`
         margin-top: 0;
    `};
`;

export const Title = styled(Headline)`
    margin-bottom: ${({ theme }) => theme.spacers.M};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.desktopMin.css`
        ${theme.typography.Subheadline}
    `};
`;

export const ButtonBlock = styled.div`
    margin: 0px;
    padding: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;

export const NevermindButton = styled(SonntagButtonV2)`
    margin: 8px 8px 0px 0px;
     ${({ theme }) => theme.superQuery.all.and.maxWidth.desktopMin.css`
            margin: 0px 8px 0px 0px;
            width: 50%;
    `};
`;

export const Button = styled(SonntagButtonV2)`
    margin: 8px 16px 0 0;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.desktopMin.css`
            margin: 0 0 16px 0;
            width: 50%;
    `};

`;


